import React, {Component} from 'react';
import './home.css';
import 'react-circular-progressbar/dist/styles.css';
import logoImage from '../../resources/images/autofact-logo-new.svg';
import {FormGroup, ControlLabel, FormControl, Grid, Row, Col, Image} from 'react-bootstrap';
import {withRouter} from 'react-router-dom';
import {setCode} from "../../redux/actionCreators";
import {connect} from "react-redux";
import config from '../../config/config';
import PlatesContainer from '../../components/plates_container/PlatesContainer';
import MainButton from '../../components/buttons/main_button/MainButton';
import FooterContainer from '../../components/footer/FooterContainer';
import TitleComponent from '../../components/title/TitleComponent';
import RefreshTimeLeft from './LeftTime';
import { textHelper } from '../../helpers/text';
import InfoBoxes from '../../components/info_boxes/InfoBoxes';
import TermsMessage from '../../components/terms_message/TermsMessage';

const FLUX_WITH_TOC = ['full_security', 'light_security', 'full_security_notary'];


class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            time: config.process_time,
            percentage: 100
        };

        this.getInitForm = this.getInitForm.bind(this);
        this.getWelcomeData = this.getWelcomeData.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.refreshTimer = this.refreshTimer.bind(this);
    }

    sources = {
        document: 'DOCUMENT'
    };

    timeUnit = config.process_time_unit_label;

    componentDidUpdate(prevProps) {
        if (this.props.expiration !== undefined && this.props.expirationSecondsToken !== undefined &&
            (
                this.props.expiration !== prevProps.expiration
                ||
                this.props.expirationSecondsToken !== prevProps.expirationSecondsToken
            )
        ) {
            this.refreshTimer();
        }
    }

    componentDidMount() {
        if (this.props.source === this.sources.document) {
            this.refreshTimer();
        }
    }

    refreshTimer = () => {
        const actualDate = new Date();
        const expirationToken = this.props.expirationSecondsToken / 60;
        const diff = (Math.abs(this.props.expiration - actualDate) / 1000 / 60);
        let newDiff;
        if (diff > 1440) {
            newDiff = (diff / 60) / 24;
            this.timeUnit = config.process_time_unit_days;
        } else if (1440 >= diff && diff > 60) {
            newDiff = diff / 60;
            this.timeUnit = config.process_time_unit_hours;
        } else {
            newDiff = diff;
        }
        this.setState({
            percentage: ((diff * 100) / expirationToken),
            time: Math.ceil(newDiff),
        });
    };


    handleChange = (event) => {
        this.props.setCode(event.target.value);
    };

    getImage = () => {
        let result = <Image src={logoImage} />;
        if (this.props.companyLogo !== undefined) {
            result = (
                <div className='content-logo'>
                    <div className='top-logo'>
                        <Image src={this.props.companyLogo} />
                    </div>
                </div>
            );

        }
        return result;
    }

    getInitForm = () => {
        return (
            <Row>
                <form onSubmit={this.props.accessAction}>
                    <Col xs={12}>
                        <p className={'welcome-text'}>
                            Acceso a la firma digital
                        </p>
                        <div className={'description-content'}>
                            <p className={'welcome-description'}>
                                Para acceder debe ingresar el código asignado al proceso. Dispone de {config.process_time} {(config.process_time_unit_label).toLowerCase()} para realizar la firma digital.
                            </p>
                        </div>
                        <div className={'form-content'}>
                            <FormGroup className={'input-content'}>
                                <ControlLabel className={'welcome-label'}>
                                    Ingrese el código del proceso
                                </ControlLabel>
                                <FormControl
                                    className={'code-input'}
                                    type={'text'}
                                    placeholder={'IDTH1K1jQS77'}
                                    value={this.props.value}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </div>
                    </Col>
                    <FooterContainer>
                        <MainButton
                            text={'Ingresar'}
                            type={'submit'}
                        />
                    </FooterContainer>
                </form>
            </Row>

        );
    };

    getWelcomeData = () => {
        const timer = this.getTimer();
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <TitleComponent bolder>Te damos la bienvenida al proceso de firma digital</TitleComponent>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <TitleComponent bold subtitle className={'name-content'}>
                            {this.props.name !== null ? textHelper.capitalize(this.props.name.toLowerCase()) : 'Nombre no definido'}
                        </TitleComponent>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <TitleComponent subtitle className={'rut-content'}>
                            RUT: {this.props.rut !== null ? textHelper.formatRut(this.props.rut) : ''}
                        </TitleComponent>
                    </Col>
                </Row>
                {timer}
                <InfoBoxes step="initial" />
                <div className={'break-next-button'}></div>
                
                

                <FooterContainer>
                    <MainButton
                        text={'Comenzar'}
                        onClick={this.props.startAction}
                    />
                    <TermsMessage />
                </FooterContainer>

            </div>
        );
    };


    getTimer = () => {
        const hasPlates = this.props.multiple ? 'has-plates' : '';
        let plates = '';
        if (hasPlates) {
            plates = <PlatesContainer plates={this.props.multiple.plates}/>
        } else if (this.props.plate) {
            plates = <PlatesContainer plates={Array.isArray(this.props.plate) ? this.props.plate : [this.props.plate]}/>
        }
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <div className={hasPlates}>
                            <RefreshTimeLeft props={this.props}/>
                        </div>
                    </Col>
                </Row>
                {plates}
            </div>
        );

    };

    render() {
        let content;
        if (this.props.hasCode === true) {
            content = this.getWelcomeData();
        } else {
            content = this.getInitForm();
        }
        return (
            <div className={'home'}>
                {this.getImage()}
                <Grid>
                    <div className={'content'}>
                        {content}
                    </div>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        code: state.code,
        name: state.name,
        rut: state.rut,
        expiration: state.expiration,
        expirationSecondsToken: state.expirationSecondsToken,
        multiple: state.multiple,
        companyLogo: state.companyLogo,
        identityType: state.identityType,
        source: state.source,
        plate: state.plate,
        componentName: state.component,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setCode(code) {
            dispatch(setCode(code));
        },
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
